import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Base } from "components/template";
import { ProgressBar } from "components/molecules";
import { Button, Input } from "components/atoms";
import { verifyEmailSchema } from "_config/formSchemas";
import { verifyEmail } from "_config/store/account/account.thunk";
import { useLocalStorage, useToast } from "_hooks";

const prefix = "v-verify-email";
const regexp = /^[0-9]$/;

const VerifyEmail = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const navigate = useNavigate();

  const { register, handleSubmit, formState: { errors }, setFocus, setValue, watch } = useForm({
    resolver: yupResolver(verifyEmailSchema),
    defaultValues: {
      a: "",
      b: "",
      c: "",
      d: ""
    }
  });

  const [onBoarding, setOnBoarding] = useLocalStorage("onBoarding");

  const { data: verifyData, isLoading } = useSelector((s) => s?.account?.verifyEmail);
  const { toast } = useToast();
  const { a, b, c, d } = watch();
  const submitRef = useRef(null);

  const onSubmit = async ({ a, b, c, d }) => {
    let { error } = await dispatch(verifyEmail({
      email: onBoarding?.email,
      code: `${a}${b}${c}${d}`
    }));
    
    if (error) toast("El código ingresado es incorrecto", "error");
  };

  useEffect(() => {
    if (onBoarding?.email === null) navigate("/account/signup")
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setFocus("a");
  }, [setFocus]);

  useEffect(() => {
    if (verifyData !== null) {
      setOnBoarding(verifyData);
      setTimeout(() => navigate("/account/createPassword", { state }), 100);
    }
  }, [verifyData]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (a?.length) {
      if (regexp.test(a)) setFocus("b");
      else setValue("a", "");
    }
  }, [a, setFocus, setValue]);

  useEffect(() => {
    if (b?.length) {
      if (regexp.test(b)) setFocus("c");
      else  setValue("b", "");
    }
  }, [b, setFocus, setValue]);

  useEffect(() => {
    if (c?.length) {
      if (regexp.test(c)) setFocus("d");
      else setValue("c", "");
    }
  }, [c, setFocus, setValue]);

  useEffect(() => {
    if (d?.length) {
      if (regexp.test(d)) submitRef?.current?.focus();
      else setValue("d", "");
    }
  }, [d, setFocus, setValue]);

  return (
    <Base
      align="normal"
      header={<ProgressBar max={6} progress={1} />}
      headerClass={"mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px] mt-10 mb-0"}
    >
      <div className={`${prefix} flex flex-wrap flex-col p-3 mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px]`}>
        <div className="flex flex-wrap flex-col gap-3 ">

          <p className="text-center text-3xl font-bold mx-auto mt-5">Verifica tu correo</p>
          <p className="text-center text-xl mx-auto mb-2">Te enviamos un correo a:</p>
          <p className="text-center text-lg font-medium mx-auto mb-5">{onBoarding?.email}</p>

          <p className="text-center text-lg mx-auto mb-5">Ingresa el código a continuación</p>
        
          <form 
            className="flex flex-wrap flex-col gap-5"
            onSubmit={handleSubmit(onSubmit)}            
          > 
            <div className="grid grid-cols-4 gap-6">
              <Input
                autoComplete="off"
                className="text-2xl text-center bg-gray-100 h-14 rounded-lg p-2 w-[100%]"
                errors={errors?.a}
                maxLength={1}
                {...register("a")}
              />
              <Input
                autoComplete="off"
                className="text-2xl text-center bg-gray-100 h-14 rounded-lg p-2 w-[100%]"
                errors={errors?.b}
                maxLength={1}
                {...register("b")}
              />
              <Input
                autoComplete="off"
                className="text-2xl text-center bg-gray-100 h-14 rounded-lg p-2 w-[100%]"
                errors={errors?.c}
                maxLength={1}
                {...register("c")}
              />
              <Input
                autoComplete="off"
                className="text-2xl text-center bg-gray-100 h-14 rounded-lg p-2 w-[100%]"
                errors={errors?.d}
                maxLength={1}
                {...register("d")}
              />
            </div>

            {/* <span className="text-gray-800 w-full text-right">
              ¿No te llegó? <span 
                className="underline cursor-pointer" 
                onClick={resend}
              >Reenviar</span>
            </span> */}

            <Button
              className="bg-primary text-white rounded-lg mt-5"
              disabled={isLoading || !!Object.keys(errors).length}
              pulse={true}
              ref={submitRef}
              spin={isLoading}
              type="submit"
            >Continuar</Button>
          </form>
        </div>
        
      </div>
    </Base>
  );
};

export default VerifyEmail;
